import './App.css';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import Page1 from './components/fullpage/page1/fullpage';
import AboutUs from './components/AboutUs';
import NavBar from './components/navbar/navBar';
import Works from './components/Works';
import Teams from './components/Teams/Teams';
import ContactUs from './components/ContactUs/contactUs';




function App() {




  return (
    <Router>
      <NavBar />
      {/* <Page1 /> */}
      <Switch>
        <Route path="/" exact component={Page1}></Route>
        <Route path="/about/" exact component={AboutUs}></Route>
        <Route path="/works/" exact component={Works}></Route>
        <Route path="/teams/" exact component={Teams}></Route>
        <Route path="/contactUs/" exact component={ContactUs}></Route>
      </Switch>
    </Router>
  );
}

export default App;
